import fileDownload from 'js-file-download'

import axiosAuth from './axiosAuth'

export const getFiles = () => axiosAuth.get('/files')

export const getFile = (fileId: string) => axiosAuth.get(`/files/${fileId}`)

export const getFileStatus = (fileId: string) =>
    axiosAuth.get(`/files/${fileId}/status`)

export const createFile = (file: FormData) =>
    axiosAuth.post('/files', file, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })

export const updateFile = (fileId: string, file: FormData) =>
    axiosAuth.put(`/files/${fileId}`, file, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })

export const deleteFile = (fileId: string) =>
    axiosAuth.delete(`/files/${fileId}`)

export const downloadFile = (fileId: string, fileName: string) =>
    axiosAuth
        .get(`/files/${fileId}/content`, {
            responseType: 'blob',
        })
        .then((response) => {
            fileDownload(response.data, fileName)
        })
